if (!customElements.get('jason-engraving')) {
  customElements.define('jason-engraving', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.details = this.querySelector('.jason-engraving__details');
      this.review = this.querySelector('.jason-engraving__review');
      this.preview = this.querySelector('.jason-engraving__preview');
      this.previewText = this.querySelector('.jason-engraving__live-text');
      this.previewInitial = this.querySelector('.jason-engraving__initial');
      this.lineTwoField = this.querySelector('.jason-engraving__line-two-field');
      this.lineTwoInput = this.lineTwoField.querySelector('input[type=text]');
      this.lineTwoFontSelect = this.lineTwoField.querySelector('select');
      this.lineTwoFontProperty = this.lineTwoField.querySelector('[name="properties[Engraving line 2 font]"]');
      this.lineTwoAlignmentSelect = this.lineTwoField.querySelector('.jason-engraving__line-two-alignment');
      this.lineTwoAlignmentProperty = this.lineTwoField.querySelector('[name="properties[Engraving line 2 alignment]"]');
      this.previewLineTwo = this.querySelector('.jason-engraving__preview-line-two');
      this.handleChange = () => this.update();
      this.handleSubmit = (event) => {
        this.update();
        if (!this.details.disabled) {
          const text = this.details.querySelector('input[type=text]');
          text.setCustomValidity(text.value.trim() ? '' : text.placeholder);
          if (!this.form.reportValidity()) {
            event.preventDefault();
            event.stopImmediatePropagation();
          } else {
            text.value = text.value.trim();
          }
        }
      };
      this.form.addEventListener('change', this.handleChange);
      this.addEventListener('input', this.handleChange);
      this.form.addEventListener('submit', this.handleSubmit, true);
      this.update();
    }
    disconnectedCallback() {
      this.form?.removeEventListener('change', this.handleChange);
      this.removeEventListener('input', this.handleChange);
      this.form?.removeEventListener('submit', this.handleSubmit, true);
    }
    update() {
      const active = this.form.querySelector('[name=id]').value === this.dataset.engravingVariant;
      this.details.hidden = !active;
      this.details.disabled = !active;
      const text = this.details.querySelector('input[type=text]');
      text.setCustomValidity('');
      const font = this.details.querySelector('input[type=radio]:checked')?.value || '';
      const placement = this.details.querySelector('[name="properties[Engraving placement]"]').value;
      const fontNumber = { 'Font 1': '1', 'Font 2': '2', 'Font 3': '3' }[font] || '1';
      this.preview.dataset.font = fontNumber;
      const showLineTwo = active && !!font && fontNumber !== '3';
      this.lineTwoField.hidden = !showLineTwo;
      this.lineTwoInput.disabled = !showLineTwo;
      this.lineTwoFontSelect.disabled = !showLineTwo;
      this.lineTwoAlignmentSelect.disabled = !showLineTwo;
      const lineTwo = showLineTwo ? this.lineTwoInput.value.trim() : '';
      const lineTwoFont = this.lineTwoFontSelect.value === 'same' ? font : this.lineTwoFontSelect.value;
      this.lineTwoFontProperty.value = lineTwoFont;
      this.lineTwoFontProperty.disabled = !showLineTwo || !lineTwo;
      this.previewLineTwo.dataset.font = { 'Font 1': '1', 'Font 2': '2', 'Font 3 lettering': '3' }[lineTwoFont] || '1';
      const alignment = ['Left', 'Center', 'Right'].includes(this.lineTwoAlignmentSelect.value) ? this.lineTwoAlignmentSelect.value : 'Center';
      this.previewLineTwo.dataset.alignment = alignment.toLowerCase();
      this.lineTwoAlignmentProperty.value = alignment;
      this.lineTwoAlignmentProperty.disabled = !showLineTwo || !lineTwo;
      this.previewLineTwo.textContent = lineTwo;
      this.previewLineTwo.hidden = !lineTwo;
      const engravingText = text.value.trim();
      this.previewText.textContent = engravingText || this.preview.dataset.placeholder;
      this.previewInitial.hidden = fontNumber !== '3' || !engravingText;
      this.previewInitial.textContent = engravingText.match(/\p{L}/u)?.[0]?.toLocaleUpperCase() || '';
      this.review.textContent = [text.value.trim(), lineTwo, font, lineTwo ? lineTwoFont : '', lineTwo ? alignment : '', placement].filter(Boolean).join(' · ');
    }
  });
}

